import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../../../theme';
import { Fare } from '../../../../types';
import cn from 'classnames';

interface Props {
	isFullFareConditions: boolean;
	fare: Fare;
	contentTableRef: React.RefObject<HTMLDivElement>;
	selectedFare?: string;
	fareIndex: number;
}

const Fare: React.FC<Props> = ({ fare, isFullFareConditions, contentTableRef, selectedFare, fareIndex }) => {
	const { t } = useTranslation('CompareFares');
	const { Fare: css } = useTheme('CompareFares');

	const selectedFareRef: React.RefObject<HTMLDivElement> = React.useRef();

	const getSelectedFareParameters = () => {
		const contentTableHeight = contentTableRef.current?.clientHeight;
		const slickList: HTMLDivElement = document.querySelector('.slick-list');

		if (contentTableHeight && selectedFareRef.current && slickList.clientHeight) {
			slickList.style.paddingBottom = `${contentTableHeight}px`;
			slickList.style.marginBottom = `-${contentTableHeight}px`;

			selectedFareRef.current.style.height = `${contentTableHeight}px`;
		}
	};

	React.useEffect(() => {
		getSelectedFareParameters();
	}, [isFullFareConditions]);

	return (
		<div className={css.headingWrp}>
			{fare.title === selectedFare && <div className={css.selectedFare} ref={selectedFareRef} />}

			<div
				data-fareindex={fareIndex + 1}
				className={cn(css.fareHeadingItem, {
					[css.fareHeadingItem_isKey]: fare.serviceClass === 'Business',
					[css.fareHeadingItem_isFirstClass]: fare.serviceClass === 'First'
				})}
			>
				<span className={css.fareHeadingItem__title}>{fare.title ? ` ${fare.title}` : ''}</span>
			</div>

			{!isFullFareConditions && fare?.image && (
				<img className={css.image} src={fare.image} alt={t(fare.title)} onLoad={getSelectedFareParameters} />
			)}
		</div>
	);
};

export default Fare;
